import React from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import withRouter from "components/Common/withRouter"
import { Tag } from "antd"

const ReleaseListItem = props => {
  return (
    <>
      <div className="d-flex">
        <div className="me-3">
          <img
            src={props.item.img}
            alt=""
            className="avatar-xs d-none d-sm-block rounded py-1 px-1 release-item-image"
            style={{ objectFit: "contain" }}
          />
        </div>
        <div
          className="align-self-center overflow-hidden me-auto"
        >
          <div>
            <h5 className="font-size-14 text-truncate mb-1">
              <a
                href={"/release-note/" + props.item.guid}
                target="_blank"
                rel="noreferrer"
              >
                {props.t(props.item.target) + " v." + props.item.version}
              </a>
            </h5>

            <p className="text-muted mb-2">{props.item.date}</p>

            {props.item.status == "Published" ? 
              <Tag color="" style={{ borderRadius: "100px" }} className="mb-2 pe-2">
                <i className="mdi mdi-check-bold me-1" style={{color: "#49a02a"}} />
                {props.t("Released") + " " + props.t(props.item.releaseDate)}
              </Tag> : 
              <Tag color="" style={{ borderRadius: "100px" }} className="mb-2">
                <i className="mdi mdi-calendar me-1 text-primary" />
                {props.t("Coming") + " " + props.t(props.item.releaseDate)}
              </Tag>
            }

            {props.item.type == "Hotfix" &&
              <Tag color="orange" style={{ borderRadius: "100px" }} className="pe-2">
                <i className="mdi mdi-fire me-1" />
                {props.t(props.item.type)}
              </Tag>
            }
          </div>
        </div>
      </div>
    </>
  )
}

ReleaseListItem.propTypes = {
  t: PropTypes.any,
  item: PropTypes.any,
}

export default withRouter(withTranslation()(ReleaseListItem))
